import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker?: string;
  title: string;
  description?: string;
  action?: ReactNode;
  align?: "left" | "center";
}

export default function SectionHeading({
  kicker,
  title,
  description,
  action,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:mb-10 ${
        align === "center" ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      }`}
    >
      <div className={align === "center" ? "max-w-2xl" : ""}>
        {kicker && (
          <div
            className={`mb-3 flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.28em] text-primary-600 ${
              align === "center" ? "justify-center" : ""
            }`}
          >
            <span className="h-[1px] w-6 bg-primary-400"></span>
            {kicker}
          </div>
        )}
        <h2 className="font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[30px]">
          {title}
        </h2>
        {description && (
          <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}